import { IApplicationState } from '../../types/redux';

export const getSubdomain = (state: IApplicationState) => state.subdomain;
